var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
export var BasicAccordion = function (_a) {
    var expanded = _a.expanded, control = _a.control, header = _a.header, handleChange = _a.handleChange, icon = _a.icon;
    return (_jsxs(Accordion, __assign({ sx: { background: expanded ? "#f7f8f9" : "white" }, expanded: expanded, onChange: handleChange }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, {}) }, { children: _jsxs(Typography, __assign({ variant: "subtitle1", fontWeight: "bold", noWrap: true, component: "div" }, { children: [icon && _jsx(Box, { component: "img", sx: {
                                paddingRight: "10px",
                                width: 55,
                                maxWidth: { xs: 55, md: 55 },
                            }, src: icon }), header] })) })), _jsx(AccordionDetails, { children: control })] })));
};
